var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{staticClass:"btn",attrs:{"round":"","color":"#f85b0f"},on:{"click":_vm.signOutOidc}},[_vm._v("退出登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }